<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล
          </a>
        </li>
        <li class="active">นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <div class="layout_filter_search()">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="wrapper_uploadsave">
                    <el-form size="mini">
                      <div class="row">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทการให้บริการ">
                            <el-select 
                              v-model="form.provider_type" 
                              @change="change_provider_type()" >
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                              <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อผู้ให้บริการ">
                            <el-select
                              v-model="form.provider_id"
                            >
                              <el-option :label="'ทั้งหมด'" value=""></el-option>
                              <el-option v-for="item in this.options" 
                                :label="item.provider_name" 
                                :key="item.id"  
                                :value="item.id">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)">
                            <el-date-picker
                              style="width: 100% !important"
                              v-model="form.month"
                              type="month"
                              placeholder="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <el-button class="btn btn-primary" @click="search(null)">ค้นหา</el-button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="tablelist">
                  <data-tables-server 
                  @query-change="search"
                    :data="regulate_list" 
                    :total="regulate_total"
                    :page-size="form.pageSize"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    style="width: 100%">
                    <el-table-column sortable="custom" prop="brand_name_th" label="ชื่อผู้ให้บริการ"></el-table-column>
                    <el-table-column prop="provider_type_th" label="ประเภทการให้บริการ" width="200"></el-table-column>
                    <el-table-column sortable="custom" prop="monthly_regulate" label="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)" align="center" width="205"></el-table-column>
                    <el-table-column prop="status" label="สถานะ"></el-table-column>
                    <el-table-column sortable="custom" prop="created_at" label="วันที่นำส่งข้อมูล" ></el-table-column>
                    <el-table-column prop="namePic" label="ดาวน์โหลดไฟล์นำส่ง" >
                      <template slot-scope="scope" >
                        <a class="hover" @click="request_file(scope.row.attache_file)">
                          <div class="img-radius" >
                            <img src="../../../public/img/icon-excel.jpg" alt />
                          </div>
                        </a>
                      </template>
                    </el-table-column>
                    <el-table-column prop="monthly_regulate" label="นำออกข้อมูลปัจจุบัน">
                      <template slot-scope="scope" >
                        <a class="hover">
                          <el-button :disabled="pending" @click="exporting(scope.row)" type="success" icon="el-icon-upload2" circle></el-button>
                        </a>
                      </template>
                    </el-table-column>
                    <el-table-column v-if="permissions.Upload_save.includes('delete')">
                      <template slot-scope="scope">
                        <el-button v-if="scope.row.version == 'latest'" @click="remove(scope.row)" type="danger" icon="el-icon-delete" circle></el-button>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import {mapState,mapActions} from "vuex"
import config from "../../../config/config";
export default {
  created() {
    this.$store.dispatch('Manage_operator/getAvailableOperator')
    const regex = /Operator/;
    this.isProvider = regex.test(this.$router.currentRoute.path)
    this.permissions = JSON.parse(atob(this.$cookies.get("user_nbtc").permission))
    this.user_id = this.$cookies.get('user_nbtc').admin_id
  },
  data() {
    return {
      user_id : null,
      isProvider: false,
      form: {
        provider_type: "",
        provider_id : "",
        month: null,
        page : 1,
        pageSize : 10,
        total : 0,
        queryInfo: null
      },
      selectDate: "",
      type: "",
      tableProps: {
        border: true
        // stripe: true,
      },
      tableShow: [],
      url : config.API_URL,
      options : [],
      permissions : null,
      pending : false
    };
  },
  computed: {
    ...mapState({
      provider_list : store=> store.Manage_operator.select_lists,
      regulate_list : store => store.Manage_internet.prepares,
      regulate_total : store => store.Manage_internet.total ,
      loading : store => store.Manage_internet.loading
    })
  },
  methods: {
    ...mapActions({
      get_monthly : "Manage_internet/get_monthly_regulate",
      remove_monthly_regulate : 'Manage_internet/remove_monthly_regulate',
      request_file : 'Manage_internet/download_monthly_regulate'
    }),
    search(queryInfo){
      this.form.pageSize = queryInfo ? queryInfo.pageSize : 10
      this.form.page = queryInfo ? queryInfo.page : 1
      this.form.queryInfo = queryInfo
      this.get_monthly(this.form)
    },
    change_provider_type(){
      this.options = !this.form.provider_type ? this.provider_list : this.provider_list.filter(item => item.provider_type == this.form.provider_type) 
    },
    remove(row){
      this.$confirm("ลบรายการนำส่งรายเดือน", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
      .then(() => {
        this.remove_monthly_regulate(row)
      })
    },
    exporting(row){
      this.pending = true
      this.$store.dispatch('Manage_internet/export_monthly_regulate', row)
      setTimeout(()=>{
        this.pending = false
      }, 1000)
    }
  }
};
</script>
<style>
  .hover :hover{
    cursor : pointer;
  }
</style>